module.exports = __webpack_public_path__ + "media/images/admin/icons/camera-699d230654d2f71111668bd861024de5.svg";